import { render } from "./PlumbingSetup.vue?vue&type=template&id=159972ad&scoped=true"
import script from "./PlumbingSetup.vue?vue&type=script&lang=js"
export * from "./PlumbingSetup.vue?vue&type=script&lang=js"

import "./PlumbingSetup.vue?vue&type=style&index=0&id=159972ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159972ad"]])

export default __exports__